import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

class InlineHeader extends React.Component {
  onMessageBarDismissed = () => {
    this.title.focus();
  }

  setTitle = (h1) => {
    this.title = h1;
  };

  renderTitleDescription() {
    if (this.props.titleDescription) {
      const { intl } = this.props;
      const translated = intl.formatMessage({ ...this.props.titleDescription });
      return (
        <p dangerouslySetInnerHTML={ { __html: translated } } />
      );
    }

    return null;
  }

  render() {
    return (
      <>
        <Row className="mb-3">
          <Col xs="auto">
            {
              this.props.headerTitle ?
                <h1 className="float-left mr-2" id="content" data-qa-item="pageHeader"
                  aria-describedby={this.props.ariaDescribedby} tabIndex="0"
                  ref={this.setTitle}
                >
                  {this.props.headerTitle}
                </h1> :
                <span id="content"></span>
            }
          </Col>
        </Row>
        <Row lg="auto" className="g-3 align-items-center mb-3">
            {this.props.children}
        </Row>
        <Row>
          <Col>
            {this.renderTitleDescription()}
          </Col>
        </Row>
      </>
    );
  }
}

InlineHeader.propTypes = {
  headerTitle: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  titleDescription: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  ariaDescribedby: PropTypes.string,
  children: PropTypes.object,
  intl: PropTypes.object,
};

export default injectIntl(InlineHeader);
